import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { EBetSplit } from "../../../core/round/interfaces";

@Component({
    selector: "payout-item",
    template: `
        <div class="payout-item__container--data"
             number-color [numberValue]="coefficient">
            <span class="payout-item__text--coefficient">x{{coefficient.toFixed(2)}} {{getExtraText()}}</span>
        </div>`,
    styleUrls: ["./payout-item.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PayoutItemComponent {
    @Input() coefficient: number = 0;
    @Input() split: EBetSplit | undefined = undefined;


    getExtraText(): string {
        switch (this.split) {
            case EBetSplit.FirstHalf:
                return "/ 2";
            default:
                return "";
        }
    }
}
